import { render } from "./section-hills-stars.vue?vue&type=template&id=eeb12094&scoped=true"
import script from "./section-hills-stars.vue?vue&type=script&lang=js"
export * from "./section-hills-stars.vue?vue&type=script&lang=js"

import "./section-hills-stars.vue?vue&type=style&index=0&id=eeb12094&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeb12094"]])

export default __exports__